import './debug.mjs';
import React from 'react';
import { render } from 'react-dom';
import { Router, Route, Switch } from 'react-router-dom';
import {createBrowserHistory, createHashHistory} from 'history';
import APPCONFIG from 'constants/Config';
import {defaultState} from 'constants/State';
import 'babel-polyfill';
import Framework from '@beardeddevops/react.framework';
import ErrorBoundaryRoute from './containers/ErrorBoundaryRoute';

import App from './containers/App';

const history = createBrowserHistory();

render(
	<Framework.Components.RootState defaultState={defaultState}>
		<Router history={history}>
			<Switch>
				<ErrorBoundaryRoute path="/">
					<App/>
				</ErrorBoundaryRoute>
			</Switch>
		</Router>
	</Framework.Components.RootState>
	,
	document.getElementById('app-container')
);
